// Bengali digits ০–৯ (U+09E6–U+09EF), as typed on a Bengali keyboard.
const bengaliDigit = /[০-৯]/g;
// Separators people type inside a number.
const separators = /[\s\-.()]/g;
// `0` (local), `880` / `+880` / `00880` (international) before the 1[3-9] + 8-digit subscriber part.
const bdMobile = /^(?:(?:\+|00)?880|0)(1[3-9]\d{8})$/;
/**
 * Normalises a Bangladesh mobile number as typed (`01712345678`, `+880 1712-345678`, `০১৭১২৩৪৫৬৭৮`) to E.164
 * (`+8801712345678`), the only form stored (CLAUDE.md §7). Returns null for anything else, including
 * landlines and foreign numbers.
 */
export function normalizePhone(input) {
    const compact = input
        .replace(bengaliDigit, (d) => String(d.charCodeAt(0) - 0x09e6))
        .replace(separators, "");
    const subscriber = bdMobile.exec(compact)?.[1];
    return subscriber === undefined ? null : `+880${subscriber}`;
}
//# sourceMappingURL=phone-normalize.js.map